export default __webpack_public_path__ + "static/privacy-policy-752cc0c9b612ab052869540a2cf07c08.jpg";